import { CalendarIcon } from "@chakra-ui/icons";
import { Button } from "@chakra-ui/react";
import { isPast } from "date-fns";
import dayjs from "dayjs";
import type { APIListingEvent } from "models/types/api-listing";
import { Link } from "react-router-dom";
import { CardRecord } from "components/cards/card-record";
import { FeedbackIcon } from "modules/vendor-portal/screens/overview/components/feedback/feedback-icon";
import { EventFeedbackInset } from "modules/vendor-portal/screens/overview/components/open-home-events/event-feedback-inset";
import { EventFooter } from "modules/vendor-portal/screens/overview/components/open-home-events/footer/event-footer";

type EventListItemProps = {
  event: APIListingEvent;
  variant?: string;
};

export function EventListItem({ event, variant }: EventListItemProps) {
  const isPastEvent = isPast(new Date(event.starts_at));
  const formattedTimeRange = `${dayjs(event.starts_at).format(
    "ddd D MMM, h:mma",
  )} – ${dayjs(event.ends_at).format("h:mma")}`;
  const showViewDetailsButton =
    event.type.id === "open_home" && !!event.feedback;

  return (
    <CardRecord
      heading={formattedTimeRange}
      leftElement={<FeedbackIcon icon={CalendarIcon} />}
      px={[4, 2]}
      renderCallToActionButton={
        showViewDetailsButton
          ? (props) => (
              <Button as={Link} to={`${event.id}`} {...props}>
                View details
              </Button>
            )
          : undefined
      }
      variant={variant}
    >
      <EventFooter event={event} />

      {isPastEvent && event.feedback?.note ? (
        <EventFeedbackInset event={event} />
      ) : null}
    </CardRecord>
  );
}
